import { IconForward } from '@shared/ui/icons';
import { formatMoney, formatMillions } from '../financierFormat';
import {
  PipelineWrapper,
  StageCard,
  StageHeader,
  StageBadge,
  StageTitle,
  StageMetrics,
  MetricCount,
  MetricAmount,
  CarryoverBadge,
  FactSubGrid,
  FactRow,
} from './styled';
import type { PipelineMetrics } from './types';

interface RequestsPipelineProps {
  pipelineStage: string;
  onStageChange: (stage: string) => void;
  metrics: PipelineMetrics;
}

export function RequestsPipeline({
  pipelineStage,
  onStageChange,
  metrics,
}: RequestsPipelineProps) {
  return (
    <PipelineWrapper>
      <StageCard
        $active={pipelineStage === 'forming'}
        onClick={() => onStageChange(pipelineStage === 'forming' ? 'all' : 'forming')}
      >
        <StageHeader>
          <StageBadge>1</StageBadge>
          <StageTitle>Сформировано</StageTitle>
        </StageHeader>
        <StageMetrics>
          <MetricCount>{metrics.formingCount} заявок</MetricCount>
          <MetricAmount>{formatMoney(metrics.formingAmount)}</MetricAmount>
        </StageMetrics>
      </StageCard>

      <StageCard
        $active={pipelineStage === 'gates_passed'}
        $tone="#10b981"
        onClick={() => onStageChange(pipelineStage === 'gates_passed' ? 'all' : 'gates_passed')}
      >
        <StageHeader>
          <StageBadge $tone="#10b981">2</StageBadge>
          <StageTitle>Прошли 4 гейта</StageTitle>
        </StageHeader>
        <StageMetrics>
          <MetricCount>{metrics.gatesPassedCount} заявок</MetricCount>
          <MetricAmount>{formatMoney(metrics.gatesPassedAmount)}</MetricAmount>
        </StageMetrics>
      </StageCard>

      <StageCard
        $active={pipelineStage === 'approved'}
        $tone="#0ea5e9"
        onClick={() => onStageChange(pipelineStage === 'approved' ? 'all' : 'approved')}
      >
        <StageHeader>
          <StageBadge $tone="#0ea5e9">3</StageBadge>
          <StageTitle>Утверждено</StageTitle>
        </StageHeader>
        <StageMetrics>
          <MetricCount>{metrics.approvedCount} заявок</MetricCount>
          <MetricAmount>{formatMoney(metrics.approvedAmount)}</MetricAmount>
          {metrics.cutCarryoverTotal > 0 && (
            <CarryoverBadge>
              <IconForward size={12} />
              Перенос в след. реестр: {formatMillions(metrics.cutCarryoverTotal)}
            </CarryoverBadge>
          )}
        </StageMetrics>
      </StageCard>

      <StageCard
        $active={pipelineStage === 'in_bank'}
        $tone="#8b5cf6"
        onClick={() => onStageChange(pipelineStage === 'in_bank' ? 'all' : 'in_bank')}
      >
        <StageHeader>
          <StageBadge $tone="#8b5cf6">4</StageBadge>
          <StageTitle>В 1С / В банке</StageTitle>
        </StageHeader>
        <StageMetrics>
          <MetricCount>{metrics.inBankCount} п/п</MetricCount>
          <MetricAmount>{formatMoney(metrics.inBankAmount)}</MetricAmount>
        </StageMetrics>
      </StageCard>

      <StageCard
        $active={pipelineStage === 'executed'}
        $tone="#10b981"
        onClick={() => onStageChange(pipelineStage === 'executed' ? 'all' : 'executed')}
      >
        <StageHeader>
          <StageBadge $tone="#10b981">5</StageBadge>
          <StageTitle>Факт по выписке</StageTitle>
        </StageHeader>
        <FactSubGrid>
          <FactRow $color="#10b981">
            <span>Оплачено всего:</span>
            <span>{formatMoney(metrics.paidTotal)}</span>
          </FactRow>
          <FactRow $color="#f59e0b">
            <span>в т.ч. частично:</span>
            <span>{formatMoney(metrics.partiallyPaidTotal)}</span>
          </FactRow>
          <FactRow>
            <span>Не оплачено:</span>
            <span>{formatMoney(metrics.unpaidTotal)}</span>
          </FactRow>
        </FactSubGrid>
      </StageCard>
    </PipelineWrapper>
  );
};
